import React from 'react';
import { t } from '@lingui/macro';
import { LinkIcon } from 'components/icons';
import { Button, useToast } from '@cardboard-ui/react';
import { graphql, useFragment } from 'utils/graphClient';
import { CopyLinkButton_node$key } from './__generated__/CopyLinkButton_node.graphql';

interface CopyLinkButtonProps {
  node: CopyLinkButton_node$key;
  closeMenu?: () => void;
}

export const CopyLinkButton = ({ node, closeMenu }: CopyLinkButtonProps) => {
  const { canonicalUrl } = useFragment(nodeFragment, node);
  const toast = useToast();

  if (!canonicalUrl) {
    return <></>;
  }

  return (
    <Button
      size="sm"
      w="100%"
      rightIcon={<LinkIcon />}
      justifyContent="space-between"
      onClick={() => {
        navigator.clipboard
          .writeText(canonicalUrl)
          .then(() => {
            toast({
              status: 'success',
              title: t`Clipboard successfully copied the link`,
              duration: 3000,
            });
          })
          .catch(() => {
            toast({
              status: 'error',
              title: t`Clipboard failed to copy the link`,
              duration: 3000,
            });
          });

        closeMenu && closeMenu();
      }}
    >
      {t`Copy link`}
    </Button>
  );
};

const nodeFragment = graphql`
  fragment CopyLinkButton_node on Node {
    ... on HasCanonicalUrlInterface {
      canonicalUrl
    }
  }
`;
